import walkUpSource from "./walkup";

const sources = {
  [walkUpSource.key]: walkUpSource,
};

export const getSource = (key) => sources[key] || null;

export default sources;
